const styles = () => ({
  root: {
    flex: '1 1 auto',
    maxWidth: 570,
    display: 'flex',
    flexDirection: 'column',
  },

  header: {
    flex: '0 1 auto',
    position: 'relative',
  },

  formRoot: {
    overflowY: 'scroll',
  },

  formContent: {
    margin: '0 34px 34px 0',
  },

  title: {
    fontSize: 22,
    lineHeight: '1.06667em',
  },

  closeWrapper: {
    alignItems: 'center',
    border: 'solid 1px #e0e4e8',
    borderRadius: 21.6,
    cursor: 'pointer',
    display: 'flex',
    height: 43,
    justifyContent: 'center',
    position: 'relative',
    right: 58,
    top: 30,
    width: 42,
  },

  close: {
    color: '#b2bcc7',
  },

  actions: {
    position: 'absolute',
    right: 17,
    top: 25,
  },

  helpText: {
    marginBottom: 0,
    height: 40,
  },

  input: {
    marginBottom: 30,
  },

  spacer: {
    flex: '1 1 auto',
  },
});

export default styles;
